
<Popover :disabled="disabled" @open="handleOpen" @close="handleClose">
    <template #trigger>
        <span class="driver-popover-default-trigger">
            <slot name="trigger">{{ displayDriverName }}</slot>
        </span>
    </template>
    <template #content="{ close }">
        <div class="driver-popover-content" v-if="setCloseFunction(close)">
            <slot
                :close="close"
                :driverName="displayDriverName"
                :driverNumber="driverNumber"
                :driverId="driverId"
            >
                <div class="driver-info">
                    <div class="driver-name-row">
                        <div class="driver-name">{{ displayDriverName }}</div>

                        <Button
                            v-if="currentRoute === 'shifts'"
                            v-tooltip="'Fahrer ändern'"
                            variant="icon"
                            size="small"
                            @onClick="handleChangeDriver(close)"
                        >
                            <i class="ri-edit-line"></i>
                        </Button>
                    </div>
                    <div v-if="!showDriverNumber" class="driver-number">
                        ID: {{ driverNumber }}
                    </div>
                </div>
            </slot>

            <div class="driver-popover-actions">
                <Button
                    v-if="showRevenueButton"
                    v-tooltip="getRevenueTooltip()"
                    variant="icon"
                    size="small"
                    :disabled="isCurrentPageRevenue && isDriverFiltered"
                    :class="{
                        'current-page': isCurrentPageRevenue && isDriverFiltered,
                    }"
                    @onClick="handleNavigate('revenue', close)"
                >
                    <i class="ri-money-dollar-circle-line"></i>
                    <span class="button-hotkey">U</span>
                </Button>

                <Button
                    v-if="showWorkingTimeButton"
                    v-tooltip="getWorkingTimeTooltip()"
                    variant="icon"
                    size="small"
                    :disabled="isCurrentPageWorkingTime && isDriverFiltered"
                    :class="{
                        'current-page': isCurrentPageWorkingTime && isDriverFiltered,
                    }"
                    @onClick="handleNavigate('working-time', close)"
                >
                    <i class="ri-time-line"></i>
                    <span class="button-hotkey">A</span>
                </Button>

                <Button
                    v-if="showShiftsButton"
                    v-tooltip="getShiftsTooltip()"
                    variant="icon"
                    size="small"
                    :disabled="isCurrentPageShifts && isDriverFiltered"
                    :class="{ 'current-page': isCurrentPageShifts && isDriverFiltered }"
                    @onClick="handleNavigate('shifts', close)"
                >
                    <i class="ri-repeat-line"></i>
                    <span class="button-hotkey">S</span>
                </Button>

                <Button
                    v-if="showTripsButton"
                    v-tooltip="getTripsTooltip()"
                    variant="icon"
                    size="small"
                    :disabled="isCurrentPageTrips && isDriverFiltered"
                    :class="{ 'current-page': isCurrentPageTrips && isDriverFiltered }"
                    @onClick="handleNavigate('trips', close)"
                >
                    <i class="ri-steering-2-line"></i>
                    <span class="button-hotkey">E</span>
                </Button>

                <Button
                    v-if="showCardPaymentsButton"
                    v-tooltip="getCardPaymentsTooltip()"
                    variant="icon"
                    size="small"
                    :disabled="isCurrentPageCardPayments && isDriverFiltered"
                    :class="{
                        'current-page': isCurrentPageCardPayments && isDriverFiltered,
                    }"
                    @onClick="handleNavigate('card-payments', close)"
                >
                    <i class="ri-bank-card-line"></i>
                    <span class="button-hotkey">K</span>
                </Button>

                <Button
                    v-if="showEmployeesButton"
                    v-tooltip="getEmployeesTooltip()"
                    variant="icon"
                    size="small"
                    :disabled="isCurrentPageEmployees && isDriverFiltered"
                    :class="{
                        'current-page': isCurrentPageEmployees && isDriverFiltered,
                    }"
                    @onClick="handleNavigate('employees', close)"
                >
                    <i class="ri-team-line"></i>
                    <span class="button-hotkey">M</span>
                </Button>
            </div>

            <div v-if="$slots.actions" class="driver-popover-custom-actions">
                <slot
                    name="actions"
                    :close="close"
                    :driverNumber="driverNumber"
                    :driverId="driverId"
                    :driverName="displayDriverName"
                />
            </div>
        </div>
    </template>
</Popover>
